import { TSelectedEntity } from '../../types/node';
import { EdgePropertyPanel } from './EdgePropertyPanel';
import { NodePropertyPanel } from './NodePropertyPanel';
import { TriggerPropertyPanel } from './TriggerPropertyPanel';

export const PropertyPanel = ({
  selectedEntity,
}: {
  selectedEntity: TSelectedEntity;
}) => {
  let jsx;
  if (selectedEntity.type === 'node') {
    jsx = <NodePropertyPanel selectedEntity={selectedEntity} />;
  } else if (selectedEntity.type === 'edge') {
    jsx = <EdgePropertyPanel selectedEntity={selectedEntity} />;
  } else if (selectedEntity.type === 'trigger') {
    jsx = <TriggerPropertyPanel selectedEntity={selectedEntity} />;
  }
  return <div className="p-4 w-96 flex flex-col gap-4">{jsx}</div>;
};
